<template>
  <el-watermark v-if="watermarkSettings" :font="config.font" :content="config.content">
    <el-config-provider :locale="appStore.locale" :size="appStore.size">
      <router-view />
    </el-config-provider>
  </el-watermark>
</template>

<script setup lang="ts">
import { useSettingsStore } from '@/store/modules/settings';
import { handleThemeStyle } from '@/utils/theme';
import { useAppStore } from '@/store/modules/app';
import { isDark } from '@/layout/composables/dark';

const appStore = useAppStore();
const watermarkSettings = ref(true);

const config = reactive({
  content: ['taa88.com', 'taseninfo.cn'],
  font: {
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.03)'
  },
  zIndex: -1,
  rotate: -22,
  gap: [100, 100] as [number, number],
  offset: [] as unknown as [number, number]
});
const font = reactive({
  color: 'rgba(0, 0, 0, .03)'
});
// const fontContent = ref('taSenInfo.cn');
watch(
  isDark,
  (value) => {
    config.font.color = value ? 'rgba(255, 255, 255, .03)' : 'rgba(0, 0, 0, .06)';
  },
  { immediate: true }
);

onMounted(() => {
  nextTick(() => {
    // 初始化主题样式
    handleThemeStyle(useSettingsStore().theme);
  });
});
</script>
